<template>
    <div class="shop_register">
        <header-section :subnav_show="false" :change_color="true"></header-section>
        <div class="shop_login_bg">
            <div class="shop_login_block width_center_1200">
                <div class="login_left"><router-link to="/">&nbsp;</router-link></div>
                <div class="login_right">
                    <div class="login_block">
                        <div class="login_title">
                            <ul>
                                <!-- <li @click="$router.push('/user/register')">注册账号</li> -->
                                <li>忘记密码</li>
                                <!-- <li @click="$router.push('/user/login')">账号登录</li> -->
                            </ul>
                        </div>
                        <div class="login_input">
                            <div class="input_block"><el-input v-model="info.mobile" type="text" placeholder="手机号" /></div>
                            <div class="input_block">
                                <el-input v-model="info.newPassword" :type="passwordflag1?'text':'password'" placeholder="新密码">
                                    <span slot="suffix" @click="passwordflag1 = !passwordflag1">
                                    <img src="@/static/img/public/open.png" v-if="passwordflag1" alt="" />
                                    <img src="@/static/img/public/close.png" v-else alt="" />
                                </span>
                                </el-input>
                            </div>
                            <div class="input_block">
                                <el-input v-model="info.confirmPassword" :type="passwordflag2?'text':'password'" placeholder="确认密码">
                                <span slot="suffix" @click="passwordflag2 = !passwordflag2">
                                    <img src="@/static/img/public/open.png" v-if="passwordflag2" alt="" />
                                    <img src="@/static/img/public/close.png" v-else alt="" />
                                </span>
                            </el-input></div>
                            <div class="input_block">
                                <el-input v-model="info.code" type="text" class="yzm" placeholder="短信验证码" />
                                <input class="send" type="button" style="background: #052bfb;" v-if="show" @click="send_sms()" value="发送验证码" />
                                <input class="send" type="button" style="background: #052bfb;" v-else disabled :value="count+'s后重新发送'" />
                            </div>
                        </div>
                        <div class="login_btn" @click="to_register">
                            修改密码
                        </div>

                        <div class="login_btn_b">
                            <router-link to="/user/register">没有账号？</router-link>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <footer-section></footer-section>
    </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"
export default {
    components: {
        HeaderSection,
        FooterSection,
    },
    props: {},
    data() {
      return {
        login_adv:"~@/static/img/bg/login-bg.jpg",
          info:{
              mobile:'',
              newPassword:'',
              confirmPassword:'',
              code:'',
          },
          show: true,
          count: '',
          timer: null,
          passwordflag1: false,
          passwordflag2: false
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 发送短信
        // send_sms:function(){
        //     if(this.$isEmpty(this.info.phone)){
        //         return this.$message.error('请先填写手机号码');
        //     }
        //     this.$post(this.$api.homeSendSms,{phone:this.info.phone,is_type:5}).then(res=>{
        //         if(res.code == 200){
        //             return this.$message.success(res.msg);
        //         }else{
        //             return this.$message.error(res.msg);
        //         }
        //     });
        // },
        // 发送短信
        send_sms:function(){
            if(this.$isEmpty(this.info.mobile)){
                return this.$message.error('手机号码不能为空');
            }
            const params={
                mobile:this.info.mobile
            }
            this.$post(this.$api.sendcode,JSON.stringify(params)).then(res=>{
                if(res.code === 0){
                    return this.$message.success("验证码已发送");
                }else{
                    return this.$message.error(res.msg);
                }
            });
            //倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.show = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        to_register:function(){
            if(this.$isEmpty(this.info.mobile)){
                return this.$message.error('手机号码不能为空');
            }
            if(this.$isEmpty(this.info.newPassword) || this.$isEmpty(this.info.confirmPassword)){
                return this.$message.error("密码不能为空")
            }
            if(this.$isEmpty(this.info.code))
            {
                return this.$message.error('短信验证码不能为空')
            }
            if(this.info.confirmPassword != this.info.newPassword){
                return this.$message.error('密码输入不一致');
            }

            const params = {
                mobile: this.info.mobile,
                code: this.info.code,
                newPassword: this.info.newPassword
            }
            this.$put(this.$api.userResetPwd, params).then(res=>{
                if(res.code == 0){
                    this.$message.success("密码修改成功");
                    this.$router.push('/user/login');
                }else{
                    return this.$message.error(res.msg);
                }
            });
        }

    },
    created() {
        
    },
    mounted() {},
	beforeDestroy() {
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
		}
	}
};
</script>
<style lang="scss" scoped>
.shop_login_bg{
    width: 100%;
    height: 600px;
    background: url("~@/static/img/bg/login-bg.png");
    background-size: cover;
    position: relative;
}
.login_left{
    float: left;
    width: 50%;
    box-sizing: border-box;
    height: 550px;
}
.login_right{
    float: right;
    width: 50%;
    box-sizing: border-box;
    .login_block{
        position: absolute;
        right: 15vw;
        // width: 400px;
        background: #fff;
        // height: 450px;
        // float: right;
        box-sizing: border-box;
        padding: 40px;
        margin-top:80px;
        padding-bottom: 25px;
        .login_title{
            width: 280px;
            margin:0 auto;
            ul:after{
                clear:both;
                display:block;
                content:'';
            }
            ul li{
                float: left;
                margin-right: 20px;
                font-size: 20px;
                color:#444;
                
            }
            ul li:hover{
                // color:#ca151e;
            }
            ul li.colors{
                color:#ca151e;
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        .login_input{
            margin-top: 20px;
            .input_block{
                margin:15px auto;
                width: 320px;
                input{
                    height: 35px;
                    width: 320px;
                    border:1px solid #e1e1e1;
                    outline:none;
                    padding:0 10px;
                    box-sizing: border-box;
                }
                .el-input.yzm{
                    width: 160px;
                    float: left;
                }
                input.send{
                    background: #41ac05;
                    color:#fff;
                    width: 140px;
                    margin-left: 20px;
                    border: none;
                    cursor: pointer;
                }
                ::v-deep .el-input__suffix-inner{
                    line-height: 32px;
                    img{
                        vertical-align: middle;
                        cursor: pointer;
                        margin-right: 10px;
                    }
                }
            }
        }
        .login_btn{
            color:#fff;
            background: #052bfb;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            a{
                color:#fff;
            }
        }
        .el-divider__text{
            color:#999;
        }
        .login_btn_b{
            text-align: right;
            font-size: 12px;
            color:#666;
            line-height: 45px;
            a{
                color:#666;
            }
            a:hover{
                color:#ca151e;
            }
        }
        .other_login{
            width: 82px;
            margin:0 auto;
            ul li{
                float: left;
                margin-right: 20px;
                i{
                    font-size: 28px;
                }
            }
            ul li:last-child{
                margin-right: 0;
            }
        }
        
    }
}
  ::v-deep input::-webkit-input-placeholder {
    color: #777;
  }
  ::v-deep input::-moz-input-placeholder {
    color:#777;
  }
  ::v-deep input::-ms-input-placeholder {
    color: #777;
  }
</style>